import React, { useState, useEffect } from 'react';
import Ediit from '.././../assets/icons/Ediit';
import Del from '.././../assets/icons/Del';
import { ToastContainer, toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import UploadIcon from '../../assets/icons/upload';
import { Circles } from 'react-loader-spinner';
import {
  getCompanyList,
  addCompany,
  deleteCompany,
  updateCompany,
} from '../../redux/action/auth';
import { useDispatch, useSelector } from 'react-redux';
const Campany = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [companyLogo, setCompanyLogo] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { companyData } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(getCompanyList());
  }, [1000]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [1000]);
  const [editCompany, setEditCompany] = useState(null);
  const handleEdit = (company) => {
    console.log(company, 'company');
    setPreview(company?.companyLogo);
    setEditCompany(company);
  };

  const handleSaveEdit = () => {
    const data = {
      companyName: editCompany?.companyName,
      companyLogo: editCompany?.companyLogo || preview,
    };
    dispatch(updateCompany(data, editCompany?._id));
    setTimeout(() => dispatch(getCompanyList()), 4000);
    setEditCompany(null);
  };
  const handleExport = () => {
    // Assuming `requestVehicleStat` is the data you want to export, modify it to flatten the nested structure if necessary
    const exportData = companyData.map((data) => ({
      _id: data._id,
      name: data?.companyName,
      logo: data?.companyLogo,
      createdAt: data?.createdAt,
    }));

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert the modified JSON data into a worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Requests Data');

    // Generate and download the Excel file
    XLSX.writeFile(wb, `company_list.xlsx`);
  };

  const [formData, setFormData] = useState({
    companyName: '',
    companyLogo: '',
  });
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file' && files.length > 0) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setFormData((prevData) => ({
          ...prevData,
          [name]: reader.result, // Store Base64 for file input
        }));
      };

      reader.readAsDataURL(files[0]); // Convert to Base64
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Store value for text, number, email, etc.
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.companyName && (formData.companyLogo || preview)) {
      const data = {
        companyName: formData?.companyName,
        companyLogo: formData?.companyLogo || preview,
      };
      dispatch(addCompany(data));
      setIsModalOpen(false);
      setTimeout(() => dispatch(getCompanyList()), 2000);
      setFormData({
        companyName: '',
        companyLogo: '',
      });
    } else {
      toast.error('Please fill both required fields');
    }
  };

  const [isToolTipOpen, setIsToolTipOpen] = useState(null);
  const openToolTip = (userId) => setIsToolTipOpen(userId);
  const closeToolTip = () => setIsToolTipOpen(null);
  const confirmDelete = (userId) => {
    dispatch(deleteCompany(userId));
    setTimeout(() => dispatch(getCompanyList()), 2000);
    closeToolTip();
  };

  const [preview, setPreview] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert file to Base64
      reader.onloadend = () => {
        setPreview(reader.result); // Show preview
        setEditCompany({ ...editCompany, companyLogo: reader.result }); // Store Base64
      };
    }
  };

  const [previewForNew, setPreviewForNew] = useState(null);
  const handleFileChangeForNew = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert file to Base64
      reader.onloadend = () => {
        setPreviewForNew(reader.result); // Show preview
        setFormData({ ...formData, companyLogo: reader.result }); // Store Base64
      };
    }
  };

  useEffect(() => {
    console.log(preview);
  }, [preview]);
  return (
    <div className='p-6 bg-gray-100 min-h-screen'>
      <ToastContainer />

      {!loading ? (
        <>
          {' '}
          <div className='flex items-center justify-between bg-[#FFFFFF] p-2'>
            <h1 className='text-2xl font-bold'>Company</h1>
            <div className='ml-auto flex items-center space-x-4'>
              <span
                onClick={() => handleExport()}
                className='px-4 py-2 bg-[#1E90FE] text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out cursor-pointer'
              >
                Export Excel
              </span>
              <button
                onClick={() => setIsModalOpen(true)}
                className='px-4 py-2 bg-[#1E90FE] text-white font-semibold rounded-lg hover:bg-white hover:text-black transition-colors duration-300 ease-in-out cursor-pointer'
              >
                Add Company
              </button>
            </div>
          </div>
          <div className='overflow-x-auto'>
            <table className='min-w-full table-auto'>
              <thead className='text-gray-600 uppercase text-sm leading-normal'>
                <tr>
                  <th className='py-3 px-6 text-left'>Names</th>
                  <th className='py-3 px-6 text-left'>Date</th>
                  <th className='py-3 px-6 text-left'>Logo</th>
                  <th className='py-3 px-6 '>Action</th>
                </tr>
              </thead>
              <tbody className='text-gray-700 text-sm'>
                {companyData.map((obj, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-200 ${
                      index % 2 === 0 ? 'bg-gray-100' : 'bg-white'
                    }`}
                  >
                    <td className='py-3 px-6 text-left'>{obj.companyName}</td>
                    <td className='py-3 px-6 text-left'>
                      {new Date(obj.createdAt).toLocaleDateString('en-CA')}
                    </td>
                    <td className=' justify-center items-center'>
                      {obj?.companyLogo ? (
                        <button
                          onClick={() => {
                            setCompanyLogo(obj?.companyLogo);
                            setIsOpen(true);
                          }}
                        >
                          <img
                            className='w-10 h-10 cursor-pointer relative left-5'
                            src={obj.companyLogo}
                            alt='No company logo'
                          />
                        </button>
                      ) : (
                        ''
                      )}
                    </td>

                    <td className='py-3 px-6 text-center flex justify-center space-x-4 relative'>
                      <button
                        className='text-green-500 hover:text-green-700'
                        onClick={() => handleEdit(obj, index)}
                      >
                        <Ediit />
                      </button>
                      <button
                        className='text-red-500 hover:text-red-700'
                        onClick={() => openToolTip(obj._id)}
                      >
                        <Del />
                      </button>

                      {/* Tooltip */}
                      {isToolTipOpen === obj._id && (
                        <div className='absolute top-10 left-[-40px] mt-2 bg-white p-4 rounded shadow-lg border z-[9999]'>
                          <p className='text-gray-700'>
                            Do you really want to delete this company?
                          </p>
                          <div className='flex justify-between mt-4'>
                            <button
                              className='px-3 py-1 bg-gray-300 rounded hover:bg-gray-400'
                              onClick={closeToolTip}
                            >
                              Cancel
                            </button>
                            <button
                              className='px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600'
                              onClick={() => confirmDelete(obj._id)}
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {isOpen && (
            <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
              <div className='bg-white p-4 rounded-lg shadow-lg text-center'>
                <img
                  className='w-40 h-40 mx-auto my-4'
                  src={companyLogo}
                  alt='QR Code'
                />
                <button
                  onClick={() => {
                    setIsOpen(false);
                  }}
                  className='text-center bg-red-500 text-white px-4 py-2 rounded-md'
                >
                  Close
                </button>
              </div>
            </div>
          )}
          {isModalOpen && (
            <div
              className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'
              onClick={() => setIsModalOpen(false)} // Close modal on outside click
            >
              <div
                onClick={(e) => e.stopPropagation()} // Prevent click from propagating
                className='bg-white rounded-lg shadow-lg p-6 w-96'
              >
                <h2 className='text-xl font-bold mb-4'>Add Company</h2>
                <form onSubmit={handleSubmit}>
                  <div className='mb-4'>
                    <input
                      type='text'
                      name='companyName'
                      placeholder='Enter company name'
                      className='w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                      value={formData.companyName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='mb-4'>
                    <div className='mb-4'>
                      <div>
                        <label className='block text-sm font-medium text-gray-700 mb-2'>
                          Logo
                        </label>
                        <div className='cursor-pointer border-2 border-dashed border-gray-300 rounded-lg p-6 text-center'>
                          <label
                            htmlFor='vehicleDetailURL'
                            className='flex flex-col items-center space-y-2'
                          >
                            <input
                              type='file'
                              accept='.png'
                              onChange={(e) =>
                                handleFileChangeForNew(e, 'vehicleDetailURL')
                              }
                              className='hidden'
                              id='vehicleDetailURL'
                            />

                            {previewForNew == 'null' ||
                            previewForNew == null ? (
                              <>
                                {' '}
                                <UploadIcon />
                                <p className='text-sm text-gray-500'>
                                  Drag and drop files to upload
                                </p>
                                <p className='text-xs text-gray-400'>
                                  Only PNG and PDF files are supported.
                                </p>
                              </>
                            ) : (
                              <img
                                width={200}
                                height={200}
                                src={previewForNew}
                                alt='No image selected'
                              />
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='flex justify-end space-x-2'>
                    <button
                      type='button'
                      onClick={() => setIsModalOpen(false)}
                      className='px-4 py-2 bg-gray-300 text-black rounded-lg hover:bg-gray-400'
                    >
                      Cancel
                    </button>
                    <button
                      type='submit'
                      className='px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600'
                    >
                      Add Company
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
          {editCompany && (
            <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
              <div className='bg-white p-6 rounded-lg shadow-lg w-1/3'>
                <h2 className='text-xl font-bold mb-4'>Edit Company</h2>
                <div className='mb-4'>
                  <label className='block text-gray-700'>Name</label>

                  <input
                    type='text'
                    className='w-full p-2 border border-gray-300 rounded'
                    value={editCompany.companyName}
                    onChange={(e) =>
                      setEditCompany({
                        ...editCompany,
                        companyName: e.target.value,
                      })
                    }
                  />
                </div>

                <div className='mb-4'>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                      Logo
                    </label>
                    <div className='cursor-pointer border-2 border-dashed border-gray-300 rounded-lg p-6 text-center'>
                      <label
                        htmlFor='vehicleDetailURL'
                        className='flex flex-col items-center space-y-2'
                      >
                        <input
                          type='file'
                          accept='.png'
                          onChange={(e) =>
                            handleFileChange(e, 'vehicleDetailURL')
                          }
                          className='hidden'
                          id='vehicleDetailURL'
                        />

                        {preview == 'null' || preview == null ? (
                          <>
                            {' '}
                            <UploadIcon />
                            <p className='text-sm text-gray-500'>
                              Drag and drop files to upload
                            </p>
                            <p className='text-xs text-gray-400'>
                              Only PNG and PDF files are supported.
                            </p>
                          </>
                        ) : (
                          <img
                            width={200}
                            height={200}
                            src={preview}
                            alt='No image selected'
                          />
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                <div className='flex justify-end'>
                  <button
                    className='px-4 py-2 bg-gray-300 rounded mr-2'
                    onClick={() => setEditCompany(null)}
                  >
                    Cancel
                  </button>
                  <button
                    className='px-4 py-2 bg-blue-500 text-white rounded'
                    onClick={handleSaveEdit}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Circles
            height='40'
            width='40'
            color='#1E90FF'
            ariaLabel='loading'
          />
        </div>
      )}
    </div>
  );
};

export default Campany;
